function onSubmit() {
    const form = document.querySelector("#hcaptcha")?.closest<HTMLFormElement>("form");
    if (form && $(form).valid()) {
        form.submit();
    }
}

// Register the callback function with HCaptcha
window.addEventListener('load', function () {
    const form: HTMLFormElement = document.querySelector("#hcaptcha")?.closest<HTMLFormElement>("form") as HTMLFormElement

    // Handle form submission (e.g., when user presses Enter or clicks submit button)
    form.addEventListener("submit", (event: SubmitEvent) => {
        event.preventDefault()

        // $().valid() performs validation and adds the error messages to the DOM, as well as returning the status
        if ($(form).valid()) {
            void hcaptcha.execute() // HCaptcha will call onSubmit after it's done
        }
    })
})


function onHcaptchaLoad() {
    if (typeof(hcaptcha) === "undefined")
        return

    const siteKey = $("#hcaptcha").data("siteKey") as string
    const options: ConfigRender = {
        callback: onSubmit,
        sitekey: siteKey
    }
    hcaptcha.render("hcaptcha", options)
}

$(() =>
{
    const script = document.createElement('script');
    script.src = "https://js.hcaptcha.com/1/api.js?recaptchacompat=off&render=explicit";
    script.async = true;
    script.defer = true;
    script.onload = onHcaptchaLoad;
    document.head.appendChild(script);
});
